/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ChatManagementEditChatStatusResponse } from './ChatManagementEditChatStatusResponse';

export type ChatManagementEditChatStatusResponseApiRespoonse = {
    data?: ChatManagementEditChatStatusResponse;
    status?: ChatManagementEditChatStatusResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ChatManagementEditChatStatusResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

